import Vue from 'vue'
import { isEmpty, every } from 'lodash'
import { getCachedWorksheet, setCachedWorksheet } from '../services/sheet_cache'

const CacheModule = {
  state: {
    cache: {}
  },

  getters: {
    allSpreadsheetsCached: (_, getters) => ({ id: spreadsheetId, worksheets }) => {
      // are all of this sheet's worksheets cached here already?
      return !isEmpty(worksheets) && every(worksheets, ({ id }) => {
        return !!getters.sheetValues(spreadsheetId, id)
      })
    },

    cacheKey: () => (spreadsheetId, worksheetId) => {
      const key = `${spreadsheetId}-${worksheetId}`
      if(!spreadsheetId || !worksheetId) {
        throw new Error(`Bad cacheKey! "${key}"`)
      }
      return key
    },

    sheetValues: (state, getters) => (spreadsheetId, worksheetId) => {
      const key = getters.cacheKey(spreadsheetId, worksheetId)
      return state.cache[key]
    }
  },

  mutations: {
    cache(state, { key, values }) {
      Vue.set(state.cache, key, values)
    },

    patchCacheCell(state, { key, rowIndex, colIndex, value }) {
      const rows = state.cache[key]
      if (!rows || !rows[rowIndex]) return
      const newRow = [...rows[rowIndex]]
      newRow[colIndex] = value
      const newValues = [...rows]
      newValues[rowIndex] = newRow
      Vue.set(state.cache, key, newValues)
    }
  },

  actions: {
    cacheSheet({ commit, getters }, { spreadsheetId, worksheets }) {
      return Bluebird.map(worksheets, ({ id, values = [] }) => {
        const key = getters.cacheKey(spreadsheetId, id)
        // we have our key and values
        // cache here in the store
        commit("cache", { key, values } )
        // cache in IDB
        return setCachedWorksheet(key, values)
      })
    },

    loadIDBCache({ commit, getters }, { id: spreadsheetId, worksheets }) {
      return !isEmpty(worksheets) && Bluebird.map(worksheets, ({ id }) => {
        const key = getters.cacheKey(spreadsheetId, id)

        return getCachedWorksheet(key)
          .then((values) => {
            commit("cache", { key, values })
          })
      })
    }
  }
}

export default CacheModule
